import { IconDefinition } from '@ant-design/icons-angular';

export const InsertRowLeftOutline: IconDefinition = {
    name: 'insert-row-left',
    theme: 'outline',
    icon: '<svg viewBox="64 64 896 896" focusable="false"><defs><style /></defs><path d="M248 112h-80c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8zm584 0H368c-17.7 0-32 14.9-32 33.3v733.3c0 18.4 14.3 33.3 32 33.3h464c17.7 0 32-14.9 32-33.3V145.3c0-18.4-14.3-33.3-32-33.3zM568 840H408V664h160v176zm0-240H408V424h160v176zm0-240H408V184h160v176zm224 480H632V664h160v176zm0-240H632V424h160v176zm0-240H632V184h160v176z" /></svg>'
}